module.exports = __webpack_public_path__ + "static/media/our-story-small.23068f9b.webp";